import { StyleSheet, Text, type StyleProp, type TextProps, type TextStyle } from 'react-native';

import { colors, fonts, fontSizes } from '@/constants/theme';

type Tone = 'muted' | 'onDark' | 'accent';

export interface OverlineProps extends Omit<TextProps, 'style'> {
  children: string;
  tone?: Tone;
  style?: StyleProp<TextStyle>;
}

/**
 * Tiny uppercase eyebrow label. Per handoff app.css `mp-overline`: 10pt,
 * 700 weight, 0.12em tracking, muted tone. Used above section headings
 * and on labels inside dark cards (e.g. "AVAILABLE TO CASH OUT").
 */
export function Overline({ children, tone = 'muted', style, ...rest }: OverlineProps) {
  return (
    <Text style={[styles.base, TONES[tone], style]} {...rest}>
      {children}
    </Text>
  );
}

const TONES: Record<Tone, TextStyle> = {
  muted: { color: colors.textMuted },
  onDark: { color: colors.textOnDarkMuted },
  accent: { color: colors.electricGreen },
};

const styles = StyleSheet.create({
  base: {
    fontFamily: fonts.bodyBold,
    fontSize: fontSizes.xs,
    textTransform: 'uppercase',
    letterSpacing: 1.4,
  },
});
